'use client'

import { fetchSuccess } from '@/shared/store/slice/cartSlice'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { redirect, useSearchParams } from 'next/navigation'
import { getOrderidFromSession } from '@/shared/store/slice/cartSlice'
import { IoInformationCircleOutline } from "react-icons/io5";

export const OrderSuccessPage = () => {
    const dispatch = useDispatch()
    const search = useSearchParams()
    const navigate = (path) => redirect(path)
    const queryParams = new URLSearchParams(search)

    const { orderId, paymentMethodValue } = useSelector(
        (state) => state.cartActions
    )

    const transactionId = queryParams.get('transaction_id')

    useEffect(() => {
        if (transactionId && !orderId) {
            dispatch(getOrderidFromSession())
        }
    }, [])

    useEffect(() => {
        if (!(orderId || transactionId)) {
            navigate('/')
        }
    }, [])

    if (paymentMethodValue === 'modulbank' && !transactionId) {
        return <div>Проблемы с оплатой</div>
    }

    const { userAuth, userInfo } = useGetIsAuthUser()

    useEffect(() => {
        if (!transactionId && !orderId) return
        dispatch(
            fetchSuccess({
                is_user_auth: userAuth,
                user_id: userAuth && userInfo.id ? userInfo.id : 0,
                transaction_id: transactionId,
            })
        )
    }, [])

    return (
        <div>
            <p>Ваш заказ № {orderId} принят!</p>
            {orderId && transactionId && <p>Заказ оплачен.</p>}
            <p>Заказ передаётся на сборку.</p>
            <p>
                Если у вас возникли вопросы, пожалуйста, свяжитесь с нами любым
                удобным для Вас способом.
            </p>
            <p>Мы работаем с понедельника по пятницу с 10 до 18 часов.</p>
            <p>Благодарим Вас за выбор BTpeel и обращение на наш сайт!</p>

            {/* Блок уведомления об отмене заказа */}
            <div style={{
                background: '#f8f9fa',
                borderLeft: '3px solid #6c757d',
                borderRadius: '4px',
                padding: '12px 16px',
                marginTop: '20px',
                marginBottom: '20px'
            }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                    <IoInformationCircleOutline size={18} style={{ color: '#6c757d', marginTop: '2px', flexShrink: 0 }} />
                    <div style={{ fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                        <p style={{ margin: '0 0 8px 0', fontWeight: '500', color: '#333' }}>
                            Условия отмены и возврата
                        </p>
                        <ul style={{ margin: 0, paddingLeft: '16px' }}>
                            <li>До отправки заказа — отмена через личный кабинет, полный возврат без удержаний.</li>
                            <li>После отправки — отмена через ЛК недоступна. Возврат возможен только после поступления заказа в ПВЗ, с удержанием стоимости доставки.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <Button onClick={() => navigate('/')}>Продолжить</Button>
        </div>
    )
}